import { getStore } from "@core/store";
export var OrganizationStore = getStore();

//# sourceMappingURL=OrganizationStore.js.map